@if (!isLoading) {
  <div
    class="page-container"
    [ngStyle]="{
      '--color50': seminarCategory.color50,
      '--color0': seminarCategory.color0,
      '--color70': seminarCategory.color70,
      '--color80': seminarCategory.color80,
      '--color90': seminarCategory.color90,
    }">
    <div class="page-navigation">
      <div class="circle-large" (click)="onCancel()">
        <div class="circle-icon">
          <i class="fa-regular fa-arrow-left fa-xl"></i>
        </div>
      </div>
    </div>
    @if (seminarDateSeries?.seminar?.cancelReason) {
      <div class="snackbar-with-icon snackbar-red">
        <i class="fa-regular fa-calendar-xmark"></i>
        {{ seminarDateSeries.seminar.cancelReason }}
      </div>
    } @else if (
      freeSeats(seminarDateSeries) <= 0 &&
      !isOnWaitlist() &&
      !isRegistered() &&
      !isPending()
    ) {
      <div class="snackbar snackbar-red">
        <i class="fa-regular fa-calendar-clock"></i>
        <span>
          Dieser Kurs ist ausgebucht. Sie können sich jedoch auf die Warteliste
          setzen lassen. Falls ein Teilnehmer seine Teilnahme absagt, werden Sie
          kontaktiert und können sich dann für den Kurs anmelden.
        </span>
      </div>
    } @else if (freeSeats(seminarDateSeries) <= 0 && isOnWaitlist()) {
      <div class="snackbar-with-icon snackbar-yellow">
        <i class="fa-regular fa-calendar-clock"></i>
        <span>
          Du bist erfolgreich in die Warteliste für dieses Seminar eingetragen.
          Sobald mindestens ein Platz frei wird, kannst du den Buchungsprozess
          abschließen.
        </span>
      </div>
    } @else if (freeSeats(seminarDateSeries) > 0 && isOnWaitlist()) {
      <div class="snackbar-with-icon snackbar-green">
        <i class="fa-regular fa-calendar"></i>
        <span>
          Es gibt {{ freeSeats(seminarDateSeries) }} freien Platz in diesem
          Seminar, damit du dich anmelden kannst.
        </span>
      </div>
    } @else if (isRegistered()) {
      <div class="snackbar-with-icon snackbar-green">
        <i class="fa-regular fa-calendar"></i>
        <span>
          Du bist erfolgreich für dieses Seminar angemeldet. Wir freuen uns auf
          deine Teilnahme.
        </span>
      </div>
    } @else if (isPending()) {
      <div class="snackbar-with-icon snackbar-yellow">
        <i class="fa-regular fa-calendar-clock"></i>
        <span>
          Deine Anmeldung für dieses Seminar wird gerade bearbeitet. Du erhältst
          eine E-Mail, sobald deine Zahlung bestätigt wurde.
        </span>
      </div>
    }
    <app-seminar-details
      [seminarDateSeries]="seminarDateSeries"
      [seminarCategory]="seminarCategory"
      [isAdmin]="
        userService.userIsAdmin(userService.currentUser$.value)
      "></app-seminar-details>
  </div>
  @if (isBookable()) {
    @if (userService.currentUser$ | async) {
      @if (freeSeats(seminarDateSeries) <= 0) {
        <div
          class="sticky-container-bottom"
          [class.position-relative]="isOnWaitlist() || isRegistered()">
          <button
            type="button"
            class="inwi-icon-text-button-large-primary"
            (click)="bookCourse()">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-calendar-clock"></i>
              </div>
              <div class="button-text">Warteliste buchen</div>
            </div>
          </button>
        </div>
      } @else if (
        freeSeats(seminarDateSeries) >=
          seminarDateSeries.waitlistAttendeeCount && isOnWaitlist()
      ) {
        <div
          class="sticky-container-bottom"
          [class.position-relative]="isOnWaitlist() || isRegistered()">
          <button
            type="button"
            class="inwi-icon-text-button-large-primary"
            (click)="convertWaitlistToBooking()">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-calendar"></i>
              </div>
              <div class="button-text">Warteliste zu Buchung umwandeln</div>
            </div>
          </button>
        </div>
      } @else {
        <div
          class="sticky-container-bottom"
          [class.position-relative]="isOnWaitlist() || isRegistered()">
          <button
            type="button"
            class="inwi-icon-text-button-large-primary"
            (click)="bookCourse()">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-calendar"></i>
              </div>
              <div class="button-text">Kurs buchen</div>
            </div>
          </button>
        </div>
      }
    } @else {
      <div class="sticky-container-bottom">
        <button
          type="button"
          class="inwi-text-button-large-secondary"
          routerLink="/login"
          [queryParams]="{ redirectUrl: redirectUrl }">
          <div class="button-content">
            <div class="button-text">
              Um das Seminar zu buchen melde dich bitte in deinem Account an.
            </div>
          </div>
        </button>
      </div>
    }
  }
} @else {
  <div class="main-container">
    <div class="main-content">
      <div class="loading-wrapper">
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
          diameter="100">
        </mat-progress-spinner>
      </div>
    </div>
  </div>
}
